export const updateTranslations = {
    // Header
    UPDATES_TITLE: {
        en: "Update Notes",
        es: "Notas de Actualización",
        pt: "Notas de Atualização"
    },
    UPDATES_SUBTITLE: {
        en: "Chronology of changes and fixes implemented in ConfigStrike.",
        es: "Cronología de los cambios y arreglos realizados en ConfigStrike.",
        pt: "Cronologia das alterações e correções feitas no ConfigStrike."
    },

    // Update 0.3.0
    V030_TITLE: {
        en: "UI & Navigation Improvements",
        es: "Interfaz y Navegación",
        pt: "Interface e Navegação"
    },
    V030_KEYSELECTOR_TITLE: {
        en: "Key Selector Rework",
        es: "Cambios en el selector de teclas",
        pt: "Mudanças no seletor de teclas"
    },
    V030_KEYSELECTOR_DESC: {
        en: "Redesigned the bind selector. Added better visibility for active keys and some visual tweaks.",
        es: "Cambiamos el diseño del selector de binds. Ahora es más fácil ver qué tecla está activa y tiene un estilo más limpio.",
        pt: "Mudamos o design do seletor de binds. Agora é mais fácil ver qual tecla está ativa e tem um estilo mais limpo."
    },
    V030_SIDEBAR_TITLE: {
        en: "New Sidebar",
        es: "Nueva barra lateral",
        pt: "Nova barra lateral"
    },
    V030_SIDEBAR_DESC: {
        en: "Added a mini-sidebar to switch faster between Dashboard, Manager, and Editor.",
        es: "Agregamos una barra lateral fija para navegar más rápido entre el panel principal, el gestor y el editor.",
        pt: "Adicionamos uma barra lateral fixa para navegar mais rápido entre o painel principal, o gerenciador e o editor."
    },
    V030_BUYEXPERIENCE_TITLE: {
        en: "Buy Binds Module Adjustments",
        es: "Ajustes en el módulo de compras",
        pt: "Ajustes no módulo de compras"
    },
    V030_BUYEXPERIENCE_DESC: {
        en: "Cleaned up the buy bind interface. Categories and items are now more organized.",
        es: "Limpiamos la interfaz de binds de compra. Las categorías e items ahora están mejor organizados.",
        pt: "Limpamos a interface de binds de compra. As categorias e itens agora estão mais organizados."
    },

    // Update 0.2.2
    V022_TITLE: {
        en: "Sound & File Management",
        es: "Sonido y Gestión de Archivos",
        pt: "Som e Gerenciamento de Arquivos"
    },
    V022_RADIO_TITLE: {
        en: "Radio Commands",
        es: "Comandos de Radio",
        pt: "Comandos de Rádio"
    },
    V022_RADIO_DESC: {
        en: "Added a module to customize radio menus with real-time previews.",
        es: "Agregamos un módulo para personalizar los menús de radio con vista previa en tiempo real.",
        pt: "Adicionamos um módulo para personalizar os menus de rádio com visualização em tempo real."
    },
    V022_EXPORT_TITLE: {
        en: "Bulk ZIP Export",
        es: "Descarga de configs en ZIP",
        pt: "Download de configs em ZIP"
    },
    V022_EXPORT_DESC: {
        en: "Now you can download all your configurations at once in a single ZIP file.",
        es: "Ya podés descargar todas tus configuraciones juntas en un archivo .ZIP.",
        pt: "Agora você pode baixar todas as suas configurações juntas em um arquivo .ZIP."
    },
    V022_LANG_TITLE: {
        en: "Translations Update",
        es: "Actualización de idiomas",
        pt: "Atualização de idiomas"
    },
    V022_LANG_DESC: {
        en: "Finished translating most modules and tooltips to English and Portuguese.",
        es: "Terminamos de traducir la mayoría de los módulos y descripciones a Inglés y Portugués.",
        pt: "Terminamos de traduzir a maioria dos módulos e descrições para Inglês e Português."
    },

    // Update 0.2.0
    V020_TITLE: {
        en: "Desktop Version & Sync",
        es: "Versión de Escritorio y Sincronización",
        pt: "Versão de Desktop e Sincronização"
    },
    V020_ELECTRON_TITLE: {
        en: "Desktop App (Electron)",
        es: "Aplicación de escritorio",
        pt: "Aplicativo de desktop"
    },
    V020_ELECTRON_DESC: {
        en: "Working desktop build that automatically detects where CS2 is installed.",
        es: "Versión funcional de escritorio que detecta automáticamente la carpeta de instalación de CS2.",
        pt: "Versão funcional de desktop que detecta automaticamente a pasta de instalação do CS2."
    },
    V020_CLOUD_TITLE: {
        en: "Cloud Save",
        es: "Guardado en la nube",
        pt: "Salvamento na nuvem"
    },
    V020_CLOUD_DESC: {
        en: "Integrated login to sync your configurations across different computers.",
        es: "Integramos el sistema de login para sincronizar tus configs en diferentes computadoras.",
        pt: "Integramos o sistema de login para sincronizar suas configurações em diferentes computadores."
    },
    V020_PREVIEWS_TITLE: {
        en: "Visual Previews",
        es: "Mejoras en vistas previas",
        pt: "Melhorias em visualizações"
    },
    V020_PREVIEWS_DESC: {
        en: "Crosshairs are now animated and we added a real-time viewmodel visualization.",
        es: "Las miras ahora tienen animación y agregamos vista previa del viewmodel en tiempo real.",
        pt: "As miras agora têm animação e adicionamos visualização do viewmodel em tempo real."
    },

    // Update 0.1.2
    V012_TITLE: {
        en: "Gallery & HUD Editor",
        es: "Galería y Editor de HUD",
        pt: "Galeria e Editor de HUD"
    },
    V012_GALLERY_TITLE: {
        en: "Pro Player Presets",
        es: "Galería de Pros",
        pt: "Galeria de Pros"
    },
    V012_GALLERY_DESC: {
        en: "Updated the galleries with configurations from professional players and direct console import.",
        es: "Actualizamos las galerías con configuraciones de jugadores profesionales e importación directa desde consola.",
        pt: "Atualizamos as galerias com configurações de jogadores profissionais e importação direta do console."
    },
    V012_HUD_TITLE: {
        en: "HUD & Radar Editor",
        es: "Editor de HUD y Radar",
        pt: "Editor de HUD e Radar"
    },
    V012_HUD_DESC: {
        en: "Added basic controls to customize the radar and HUD elements.",
        es: "Agregamos controles básicos para ajustar el radar y elementos del HUD.",
        pt: "Adicionamos controles básicos para ajustar o radar e elementos do HUD."
    },

    // Update 0.1.0
    V010_TITLE: {
        en: "Alpha Version",
        es: "Versión Alpha",
        pt: "Versão Alpha"
    },
    V010_ENGINE_TITLE: {
        en: "Modular Core",
        es: "Motor modular",
        pt: "Motor modular"
    },
    V010_ENGINE_DESC: {
        en: "Initial release of the system that separates settings into Mouse, Keyboard, and Video modules.",
        es: "Primer lanzamiento del sistema que separa la configuración en módulos para Mouse, Teclado y Video.",
        pt: "Primeiro lançamento do sistema que separa a configuração em módulos para Mouse, Teclado e Vídeo."
    },
    V010_LANG_TITLE: {
        en: "Language System",
        es: "Sistema de idiomas",
        pt: "Sistema de idiomas"
    },
    V010_LANG_DESC: {
        en: "Started the i18n implementation with Spanish and English support.",
        es: "Iniciamos la implementación de idiomas con soporte para Español e Inglés.",
        pt: "Iniciamos a implementação de idiomas com suporte para Espanhol e Inglês."
    },

    // Origin
    V_ORIGIN_TITLE: {
        en: "The Origin",
        es: "El Origen",
        pt: "A Origem"
    },
    V_ORIGIN_SUBTITLE: {
        en: "Creation of the most accurate web crosshair emulator in existence.",
        es: "Creación del emulador de crosshair web más preciso que existe.",
        pt: "Criação do emulador de crosshair web mais preciso que existe."
    },
    V_ORIGIN_DESC: {
        en: "A lot happened in between—ideas, failed designs, and prototypes that never saw the light. Finally, we found the motivation to bring this project afloat and turn it into what it is today.",
        es: "Pasaron muchas cosas en el medio: ideas, diseños fallidos y prototipos que no vieron la luz. Finalmente, encontramos la motivación para poner este proyecto a flote y convertirlo en lo que es hoy.",
        pt: "Muita coisa aconteceu no meio: ideias, designs que falharam e protótipos que não viram a luz. Finalmente, encontramos a motivação para colocar este projeto em pé e transformá-lo no que é hoje."
    }
};;
